import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Table, Progress, Select, Card, Typography, Space, Row, Col, Popover, Spin, Flex, Skeleton } from 'antd';
import commonService from '../../services/CommonService';
import { getProgressBarChart } from '../../utils/chartCalculations';
import { FilterOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { setProjectPieChartSearchList } from '../../context/reducers/userReducer';
import { UserActivity } from "../../config/BVConstants";
const columns = [
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 160
    },
    {
        title: 'Sub-Project Count',
        dataIndex: 'subProjectCount',
        key: 'subProjectCount',
        width: 140
    },
    {
        title: 'Progress',
        dataIndex: 'progress',
        key: 'progress',
        width: 160,
        render: (progress, record) => (_jsx(Progress, { percent: progress, strokeColor: record.color }))
    }
];
const ByProjectStats = (Props) => {
    var _a;
    const [dropdownData, setDropdownData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [totalsubProjectCount, setTotalsubProjectCount] = useState(0);
    const [selectedValue, setSelectedValue] = useState(undefined);
    const [initialLoading, setInitialLoading] = useState(true); // Loading state for the initial data fetch
    const [tableLoading, setTableLoading] = useState(false); // Loading state for the table data fetch
    const applicationData = useSelector((state) => state.applicationData); //useApplicationContext();
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const dispatch = useDispatch();
    const [entity, setEntiry] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [divHeight, setDivHeight] = useState(window.innerWidth < 768 ? 590 : 490);
    useEffect(() => {
        const handleResize = () => {
            setDivHeight(window.innerWidth < 768 ? 590 : 490);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        if (!Props.dataForChart) {
            const result = applicationData === null || applicationData === void 0 ? void 0 : applicationData.projectPieChartSearchList;
            if (result) {
                const updatedDropdownData = result.map((item) => {
                    var _a, _b;
                    return ({
                        value: ((_a = item.objLuBrandName) === null || _a === void 0 ? void 0 : _a.intId) + ' - ' + item.strModelName + ' - ' + item.strProjectId,
                        label: ((_b = item.objLuBrandName) === null || _b === void 0 ? void 0 : _b.strLongDesc) + ' - ' + item.strModelName + ' - ' + item.strProjectId
                    });
                });
                setDropdownData(updatedDropdownData);
                setSelectedValue(updatedDropdownData.length > 0 ? updatedDropdownData[0].value : '');
                if ((applicationData === null || applicationData === void 0 ? void 0 : applicationData.projectPieChartSearchList) != undefined &&
                    updatedDropdownData.length === 0) {
                    setLoading(false);
                }
            }
        }
    }, [applicationData === null || applicationData === void 0 ? void 0 : applicationData.projectPieChartSearchList]);
    useEffect(() => {
        commonService
            .getProjectPieChartSearchList(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList)
            .then((res) => {
            var _a, _b;
            dispatch(setProjectPieChartSearchList(res));
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Dashboard_By_Proj_Search);
        });
    }, [applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList]);
    useEffect(() => {
        if (!Props.isProjectPage) {
            if (selectedValue) {
                handleProjectChange(selectedValue);
            }
        }
    }, [selectedValue]);
    useEffect(() => {
        if (Props.isProjectPage) {
            prepareDataForChart(Props === null || Props === void 0 ? void 0 : Props.dataForChart, Props === null || Props === void 0 ? void 0 : Props.totalSubProjectCount);
            setLoading(false);
        }
    }, [Props === null || Props === void 0 ? void 0 : Props.dataForChart]);
    useEffect(() => {
        if ((tableData && tableData.length) || tableData.length == 0) {
            setInitialLoading(false);
        }
    }, [tableData]);
    function prepareDataForChart(data, totalSubProjectCount) {
        setTotalsubProjectCount(totalSubProjectCount);
        setTableData(data);
    }
    const handleProjectChange = (value) => {
        setTableLoading(true); // Start table loading
        const match = value.match(/P\d+/);
        const extractedValue = !Props.isProjectPage ? (match ? match[0] : null) : Props.projectId;
        setSelectedProjectId(extractedValue);
        commonService
            .getEntityNameByProject(extractedValue)
            .then((entityName) => {
            setEntiry(entityName);
        })
            .finally(() => {
            setLoading(false);
        });
        const requestData = {
            lstLuCompany: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList,
            strProjectId: extractedValue,
            boolLatestProject: true,
            intProjectType: 1
        };
        commonService
            .searchSubProjects(requestData)
            .then((result) => {
            var _a, _b;
            const data = getProgressBarChart(result);
            prepareDataForChart(data, result.length);
            setTableLoading(false); // Stop table loading
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Dashboard_Sub_Proj_Search);
        })
            .catch((error) => {
            setTableLoading(false); // Stop table loading on error
        });
    };
    const popoverContent = (_jsx(Space, { direction: "vertical", style: { width: '100%' }, children: selectedValue && selectedValue !== undefined ? (_jsx(Select, { value: selectedValue, onChange: (value) => setSelectedValue(value), style: { width: '100%', height: 24, zIndex: 800 }, disabled: initialLoading, children: dropdownData.map((option) => (_jsx(Select.Option, { value: option.value, children: option.label }, option.value))) })) : loading ? (_jsx(Skeleton.Input, { active: true, size: 'small', style: { width: 300 } })) : ('') }));
    const filterControls = (_jsx(Popover, { content: popoverContent, trigger: "click", getPopupContainer: (trigger) => document.body, placement: "bottomRight", style: { zIndex: 900, width: '30%' }, children: _jsx(FilterOutlined, {}) }));
    return (_jsx(Row, { gutter: [16, 16], children: _jsx(Col, { xs: 24, sm: 24, md: 20, lg: 24, xl: 24, children: _jsx(Card, { className: "dashboard-card", size: "small", title: !Props.isProjectPage ? 'By Project' : Props.title, children: _jsxs(Space, { size: 'small', direction: "vertical", style: { width: '100%', textAlign: 'center' }, children: [_jsxs("div", { style: { height: `${divHeight}px` }, children: [_jsxs(Flex, { justify: "space-between", wrap: "wrap", style: { padding: '8px', gap: '8px' }, children: [_jsx(Typography.Text, { children: !(Props === null || Props === void 0 ? void 0 : Props.isProjectPage) ? (popoverContent) : (Props === null || Props === void 0 ? void 0 : Props.documentCompletionPercent) !== undefined ? (`Document Completion : ${(_a = Props === null || Props === void 0 ? void 0 : Props.documentCompletionPercent) === null || _a === void 0 ? void 0 : _a.toFixed(2)}%`) : (_jsx(Skeleton.Input, { active: true, size: 'small', style: { width: 200 } })) }), dropdownData.length !== 0 && (_jsxs(Typography.Text, { style: { whiteSpace: 'nowrap', textAlign: 'right' }, children: ["Total SubProjects:", !Props.isProjectPage ? (_jsx(Link, { to: `/projects/details/${btoa(selectedProjectId || '')}`, target: "_blank", children: _jsx("b", { children: totalsubProjectCount }) })) : (_jsx("b", { children: totalsubProjectCount }))] }))] }), _jsx(Flex, { justify: "space-between", style: { padding: '8px' }, children: _jsx(Typography.Text, { style: { fontWeight: 500 }, children: entity !== undefined ? ('Entity Name : ' + entity) : loading ? (_jsx(Skeleton.Input, { active: true, size: 'small', style: { width: 300 } })) : ('') }) }), _jsx(Spin, { style: { height: '490px' }, spinning: initialLoading || tableLoading, size: "small", children: tableData && tableData.length > 0 ? (_jsx(Table, { scroll: {
                                            x: 500
                                        }, dataSource: tableData, columns: columns, pagination: false, size: "small" })) : (!initialLoading &&
                                        !tableLoading && _jsx(Typography.Text, { children: "No data found" })) })] }), !Props.isProjectPage ? (_jsx(Typography.Text, { style: { fontSize: '10px' }, children: "Note: Only In-Progress and On Hold projects are available here. Completed and Cancelled projects are available in Projects." })) : ('')] }) }) }) }));
};
export default ByProjectStats;
